// Sidemenu.jsx
import React, { useState, useEffect } from 'react';
import DateTime from './datetime';
import { NavLink } from 'react-router-dom';
import Logout from './Logout';
import ThresholdModal from './ThresholdModal';
import { decodeToken } from '../../utils/jwtUtils';

export default function Sidemenu() {
    const [showModal, setShowModal] = useState(false);
    const [departmentName, setDepartmentName] = useState('');

    const token = localStorage.getItem("token");
    const user = token ? decodeToken(token) : null; // decodeToken 유틸 사용

    // 로그인한 관리자 정보 가져오기 (한 번만 호출)
    useEffect(() => {
	    if (!token || !user) return;

	    if (Number(user.department) === 1) {
	        setDepartmentName('에스엠소프트');
	        return;
	    }

	    const controller = new AbortController();

	    fetch('https://safemap-dev-api.smsoft.co.kr/department', {
	        headers: {
	            Authorization: `Bearer ${token}`
	        },
	        signal: controller.signal
	    })
	        .then(async response => {
	            if (!response.ok) {
	                throw new Error(`부서 조회 실패: ${response.status}`);
	            }
	            return response.json();
	        })
	        .then(data => {
	            const department = data.department?.find(
	                item => Number(item.id) === Number(user.department)
	            );
	            setDepartmentName(department?.name || '-');
	        })
	        .catch(error => {
	            if (error.name !== 'AbortError') {
	                console.error('소속 정보 조회 실패:', error);
	                setDepartmentName('-');
	            }
	        });
	
	    return () => controller.abort();
    }, []);

    return (
        <div className="sidemenu">
            <div className="side_title">
                <p className="logo">
                    <img src="/media/logo.png" alt="곡성 스마트 안전지도 로고" />
                </p>
                <button className="map_search" onClick={() => setShowModal(true)}>
                    <img src="/media/left_seachicon.png" alt="설정" />
                </button>
                <DateTime />
            </div>

            <nav>
                <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'leftmenu01 active' : 'leftmenu01'}>대시보드</NavLink>
                <NavLink to="/map" className={({ isActive }) => isActive ? 'leftmenu02 active' : 'leftmenu02'}>스마트 지도</NavLink>
                <NavLink to="/user" className={({ isActive }) => isActive ? 'leftmenu03 active' : 'leftmenu03'}>사용자 관리</NavLink>
                <NavLink to="/device" className={({ isActive }) => isActive ? 'leftmenu04 active' : 'leftmenu04'}>장비 관리</NavLink>

		{/* 중간관리자에게 일반관리자 생성이 필요하다면 주석 해제
	    <NavLink to="/admin" className={({ isActive }) => isActive ? 'leftmenu05 active' : 'leftmenu05'}>관리자 관리</NavLink>
		*/}

	        <NavLink
		    to="/log"
		    className={({ isActive }) =>
		        isActive ? 'leftmenu06 active' : 'leftmenu06'
		    }
		>
		    {Number(user?.auth) === 1 ? '로그 및 알림 관리' : '알림 관리'}
		</NavLink>
                <NavLink to="/adminqna" className={({ isActive }) => isActive ? 'leftmenu07 active' : 'leftmenu07'}>문의사항</NavLink>
            </nav>

            {/* 로그인한 관리자 정보 표시 */}
	    {user && (
	    <div className="current_admin_info">
	        <p>현재 접속자</p>
	        <ul>
	            <li>이름 - {user.name || '-'}</li>
	            <li>소속 - {departmentName || '-'}</li>
	            <li>권한 - {
	                Number(user.auth) === 1 ? '최고관리자' :
	                Number(user.auth) === 2 ? '중간관리자' : '-'
	            }</li>
	        </ul>
	    </div>
	    )}

            <div className='logoutwrp'>
                <Logout />
            </div>

            <div className='privacy_btn'>
                <NavLink to="/privacy">개인정보처리방침</NavLink>
            </div>

            {showModal && <ThresholdModal onClose={() => setShowModal(false)} />}
        </div>
    );
}
